<template>
  <div>
    <h4 class="font-poppins">
      Login
    </h4>

    <login-form @success="$router.push({ name: 'Projects' })" />

    <router-link :to="{ name: 'password' }" data-cy="link-password" class="text-info d-inline-block mt-1">
      {{ "Forgot password?" | __t("auth__forgotten-password") }}
    </router-link>
  </div>
</template>

<script>
import LoginForm from "@/components/Forms/Login";

export default {
  name: "EmailPassword",
  components: {
    LoginForm,
  },
};
</script>
